import { booleanAttribute, Component, input } from '@angular/core';

import { SlideToggleControlComponent } from '../slide-toggle-control/slide-toggle-control.component';
import { labelPosition, TLabelPosition } from '../../models/form-field-options';
import { _ValueControlComponent } from '../../components/_value-control.component';

// Slide-toggle zonder FormControl: [value]/(valueChange). Material zit in app-slide-toggle-control.
@Component({
    selector: 'app-slide-toggle',
    templateUrl: './slide-toggle.component.html',
    standalone: true,
    imports: [
        SlideToggleControlComponent,
    ],
})
export class SlideToggleComponent
    extends _ValueControlComponent<boolean>
{
    input_ariaLabel$$     = input<string>('',                          { alias: 'ariaLabel' });
    input_hideIcon$$      = input(false,                               { transform: booleanAttribute, alias: 'hideIcon' });
    input_labelPosition$$ = input<TLabelPosition>(labelPosition.after, { alias: 'labelPosition' });

    override out_valueChange = this._out_valueChange;

    override control$$  = this._control$$;
    override disabled$$ = this._input_disabled$$;
    override label$$    = this._input_label$$;
    override readonly$$ = this._input_readonly$$;
    override value$$    = this._input_value$$;

    emit_valueChange(value: boolean): void {
        super._emit_valueChange(value);
    }
}
